import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import { Modal, Table, Button, Pagination, Spin, Empty, Select } from 'antd';
import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons';
import { ExportAlertModal } from '../common';
import { SLASH_DATE_FORMAT, DASH_DATE_FORMAT, CONST_PAGINATION } from '../../common/constants';
import { useResetOrderReport, useFetchOrderReportData, useExportReportData } from './redux/hooks';
import { useSaveReportsKeyValue } from '../reports-new/redux/saveReportsKeyValue';
import { downloadFile } from '../../common/downloadReportFunc';
import { CancelIcon, EditCalendarIcon } from '../common/CustomerIcons';
import { renderTableColumns } from '../../common/renderColumns';
import { datadogRum } from '@datadog/browser-rum';
import { ExportButton } from '../reports-new';
import { useFetchExpandedUnderMinDetails } from './redux/fetchExpandedUnderMinDetails';
import OrderDetailReportModal from './OrderDetailReportModal';
import { useTranslation } from 'react-i18next';
export default function OrderReportModal(props) {
  const { t } = useTranslation();
  const {
    orderReportData,
    fetchOrderReportDataPending,
    detailsCondition,
    dashboardConditionData,
    exportReportDataPending,
    reportsKeyValue,
    orderReportDataTotalCount,
  } = useSelector(state => ({
    orderReportData: state.dashboard.orderReportData,
    fetchOrderReportDataPending: state.dashboard.fetchOrderReportDataPending,
    detailsCondition: state.dashboard.detailsCondition,
    dashboardConditionData: state.dashboard.dashboardConditionData,
    exportReportDataPending: state.dashboard.exportReportDataPending,
    reportsKeyValue: state.reportsNew.reportsKeyValue,
    orderReportDataTotalCount: state.dashboard.orderReportDataTotalCount,
  }));
  const { fetchExpandedUnderMinDetails, fetchExpandedUnderMinDetailsPending } = useFetchExpandedUnderMinDetails();
  const { resetOrderReport } = useResetOrderReport();
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedData, setExpandedData] = useState({});
  const [loadingExpandedKey, setLoadingExpandedKey] = useState(null);
  const [caseCountFilter, setCaseCountFilter] = useState(15);
  const { fetchOrderReportData } = useFetchOrderReportData();
  const { exportReportData } = useExportReportData();
  const { saveReportsKeyValue } = useSaveReportsKeyValue();
  const [pagination, setPagination] = useState(CONST_PAGINATION);
  const [sorting, setSorting] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [isOrderDetailModalVisible, setOrderDetailModalVisible] = useState(false);
  const { title, totals, typeLabel, toggleReportModal, isReportModalVisible, modalkey } = props;
  const [revealedFields, setRevealedFields] = useState({});
  const [tableKey, setTableKey] = useState(0);

  const normalizedDashboardCondition = dashboardConditionData
    ? {
      deliveryDate: dashboardConditionData.deliveryDate
        ? moment(dashboardConditionData.deliveryDate).format(DASH_DATE_FORMAT)
        : undefined,
      sites: Array.isArray(dashboardConditionData.site) ? dashboardConditionData.site : [],
      territories: Array.isArray(dashboardConditionData.territory) ? dashboardConditionData.territory : [],
      nationalIds: Array.isArray(dashboardConditionData.nationalId) ? dashboardConditionData.nationalId : [],
      conceptIds: Array.isArray(dashboardConditionData.conceptId) ? dashboardConditionData.conceptId : [],
      accountTypes: Array.isArray(dashboardConditionData.accountType) ? dashboardConditionData.accountType : [],
      orderType: null,
    }
    : {};

  const baseDetailsCondition =
    detailsCondition && Object.keys(detailsCondition).length > 0
      ? detailsCondition
      : (title === 'Under Min' ? normalizedDashboardCondition : {});

  let statusColor;
  if (
    title === 'Open Orders' ||
    title === 'Routing' ||
    title === 'Labelled' ||
    title === 'Shipped/Invoiced'
  ) {
    statusColor = 'report-status-normal';
  } else if (title === 'Locked/Errored') {
    statusColor = 'report-status-error';
  } else {
    statusColor = 'report-status-warning';
  }
  const handleRefreshUnderMin = () => {
  // collapse any expanded rows and clear cached expanded data
  setExpandedRows([]);
  setExpandedData({});
  setSelectedRowKeys([]);
  setCheckedRowList([]);
  setLoadingExpandedKey(null);
  setSorting(undefined);
  setTableKey(k => k + 1);
  if (caseCountFilter !== 15) setCaseCountFilter(15);


  // reset pagination to first page
  setPagination(prev => ({ ...prev, pageIndex: 1 }));

  // build condition for underMin fetch — reuse baseDetailsCondition and current filters
  const condition = {
    ...baseDetailsCondition,
    orderStatus: 'underMin',
    caseCount: caseCountFilter,
    pageIndex: 1,
    pageSize: pagination.pageSize,
    
    //...(sorting ? { sortedBy: sorting.sortedBy, sort: sorting.sort } : {}),
  };

  // trigger API
  //fetchOrderReportData(condition);
};
 const paginationTotal= title === 'Under Min' ? orderReportDataTotalCount : totals;
  useEffect(() => {
    if (isReportModalVisible) {
      if (pagination.total === paginationTotal) {
        handleOrderReportList(pagination, sorting);
      } else {
        setPagination({
          ...pagination,
          total: paginationTotal,
        });
      }
    } else {
      setPagination(CONST_PAGINATION);
      setSorting(undefined);
      setShowAlert(false);
      setExpandedRows([]);  
      setExpandedData({});
      setRevealedFields({});
      if (title === 'Under Min') {
        setCaseCountFilter(15);
      }
    }
  }, [isReportModalVisible, pagination, sorting, caseCountFilter, paginationTotal]); // eslint-disable-line

   useEffect(() => {
    // Reset sorting when caseCountFilter changes
    if (caseCountFilter) {
      setSorting(undefined);
    }
  }, [caseCountFilter]);

  const columns = [
    {
      title: t('site'),
      dataIndex: 'site',
      sorter: true,
      width: 65,
      onHeaderCell: column => {
        return { width: 65 };
      },
    },
    {
      title: t('conceptId'),
      dataIndex: 'conceptId',
      sorter: true,
      width: 100,
      onHeaderCell: column => {
        return { width: 100 };
      },
    },
    {
      title: t('order#'),
      dataIndex: 'orderNumber',
      sorter: true,
      width: 95,
      onHeaderCell: column => {
        return { width: 95 };
      },
      // render: value => <div className="report-link">{value}</div>,
      toggleModal: title === 'EXPD Details'? false : true, //EXPD and subs, we do not need to show item detail
    },
    {
      title: t('customer#'),
      dataIndex: 'customerNumber',
      width: 95,
      sorter: true,
      onHeaderCell: column => {
        return { width: 95 };
      },
    },
    {
      title: t('dashboard_customerName'),
      dataIndex: 'customerName',
      width: 170,
      sorter: true,
      onHeaderCell: column => {
        return { width: 140 };
      },
    },
    {
      title: t('scName'),
      dataIndex: 'scName',
      width: 120,
      sorter: true,
      onHeaderCell: column => {
        return { width: 120 };
      },
    },
    {
      title: t('dashboard_accountType'),
      dataIndex: 'accountType',
      width: 120,
      onHeaderCell: column => {
        return { width: 120 };
      },
    },
    {
      title: t('deliveryDT'),
      dataIndex: 'deliveryDate',
      width: 100,
      onHeaderCell: column => {
        return { width: 100 };
      },
      render: value => moment(value, DASH_DATE_FORMAT).format(SLASH_DATE_FORMAT),
    },
    {
      title: t('totals'),
      dataIndex: 'totals',
      sorter: true,
      width: 100,
      onHeaderCell: column => {
        return { width: 75 };
      },
      render: value =>
        value === null || value === 0
          ? '$0.00'
          : `$${value.toLocaleString('zh', { minimumFractionDigits: 2 })}`,
    },
  ];

  const commonColumnObj = {
    title: t('itemCount'),
    dataIndex: 'itemCount',
    width: 110,
    onHeaderCell: column => {
      return { width: 110 };
    },
    sorter: true,
  };

  const errorColumnObj = {
    title: t('error'),
    dataIndex: 'errorMessage',
    width: 140,
    onHeaderCell: column => {
      return { width: 130 };
    },
  };

  const statusColumnObj = {
    title: t('status'),
    dataIndex: 'status',
    width: 80,
    onHeaderCell: column => {
      return { width: 70 };
    },
    render: value => <div className={statusColor}>{value}</div>,
  };

  const itemNoColumnObj = {
    title: t('item#'),
    dataIndex: 'itemNumber',
    width: 90,
    onHeaderCell: column => {
      return { width: 90 };
    },
    sorter: true,
  };

  const itemDescColumnObj = {
    title: t('dashboard_itemDescription'),
    dataIndex: 'itemDescription',
    width: 140,
    onHeaderCell: column => {
      return { width: 120 };
    },
  };
  const expdColumnObj = [
    {
      title: t('qnty'),
      dataIndex: 'originalQuantity',
      width: 80,
      onHeaderCell: column => {
        return { width: 70 };
      },
    },
    {
      title: t('uom'),
      dataIndex: 'unitOfMeasure',
      width: 80,
      onHeaderCell: column => {
        return { width: 70 };
      },
    },
    {
      title: t('error'),
      dataIndex: 'exceptionDescription',
      width: 140,
      onHeaderCell: column => {
        return { width: 130 };
      },
    },
    {
      title: t('status'),
      dataIndex: 'exceptionStatus',
      width: 80,
      onHeaderCell: column => {
        return { width: 70 };
      },
      render: value => <div className={statusColor}>{value}</div>,
    },
  ];
  const subsExceptionsColumnObj = [
    {
      title: t('site'),
      dataIndex: 'site',
      sorter: true,
      width: 65,
      onHeaderCell: column => {
        return { width: 65 };
      },
    },
    {
      title: t('conceptId'),
      dataIndex: 'conceptId',
      width: 150,
      sorter: true,
      onHeaderCell: column => {
        return { width: 150 };
      },
    },
    {
      title: t('customer#'),
      dataIndex: 'customerNumber',
      width: 95,
      sorter: true,
      onHeaderCell: column => {
        return { width: 95 };
      },
    },
    {
      title: t('dashboard_customerName'),
      dataIndex: 'customerName',
      width: 170,
      sorter: true,
      onHeaderCell: column => {
        return { width: 140 };
      },
    },
    {
      title: t('scName'),
      dataIndex: 'scName',
      width: 120,
      sorter: true,
      onHeaderCell: column => {
        return { width: 120 };
      },
    },
    {
      title: t('order#'),
      dataIndex: 'orderNumber',
      sorter: true,
      width: 95,
      onHeaderCell: column => {
        return { width: 95 };
      },
    },
    {
      title: t('origItem'),
      dataIndex: 'itemNumber',
      sorter: true,
      width: 110,
      onHeaderCell: column => {
        return { width: 110 };
      },
    },
    {
      title: t('origItemDesc'),
      dataIndex: 'itemDescription',
      sorter: true,
      width: 170,
      onHeaderCell: column => {
        return { width: 140 };
      },
    },
    {
      title: t('origQnty'),
      dataIndex: 'itemQuantity',
      // sorter: true,
      width: 110,
      onHeaderCell: column => {
        return { width: 100 };
      },
    },
    {
      title: t('origUnitPrice'),
      dataIndex: 'originalItemUnitPrice',
      sorter: true,
      width: 135,
      render: value =>
        value === 0
          ? '$0.000'
          : value && `$${value.toLocaleString('zh', { minimumFractionDigits: 3 })}`,
      onHeaderCell: column => {
        return { width: 100 };
      },
    },
    {
      title: t('origAlcQnty'),
      dataIndex: 'quantityAllocAgainstOnHand',
      sorter: true,
      width: 130,
      onHeaderCell: column => {
        return { width: 110 };
      },
    },
    {
      title: t('reasonCode'),
      dataIndex: 'orderReasonCode',
      sorter: true,
      width: 100,
      onHeaderCell: column => {
        return { width: 100 };
      },
    },
    {
      title: t('subItem'),
      dataIndex: 'subItemNumber',
      sorter: true,
      width: 100,
      onHeaderCell: column => {
        return { width: 80 };
      },
    },
    {
      title: t('subItemDesc'),
      dataIndex: 'subItemDescription',
      sorter: true,
      width: 170,
      onHeaderCell: column => {
        return { width: 140 };
      },
    },
    {
      title: t('subQnty'),
      dataIndex: 'subQuantity',
      // sorter: true,
      width: 110,
      onHeaderCell: column => {
        return { width: 75 };
      },
    },
    {
      title: t('subUnitPrice'),
      dataIndex: 'subItemUnitPrice',
      sorter: true,
      width: 130,
      render: value =>
        value === 0
          ? '$0.000'
          : value && `$${value.toLocaleString('zh', { minimumFractionDigits: 3 })}`,
      onHeaderCell: column => {
        return { width: 100 };
      },
    },
    {
      title: t('bosSub?'),
      dataIndex: 'bosSubRule',
      // sorter: true,
      width: 110,
      render: value => (value !== null ? String(value) : value),
      onHeaderCell: column => {
        return { width: 100 };
      },
    },
  ];

  const underMinimumColumns = [
    {
      title: '',
      key: 'expander',
      width: 10,
      fixed: 'left',
      render: (_, record) => {
        //const key = `${record.site}-${record.customerNumber}-${record.deliveryDate}`;
        const key = `${record.site}-${record.primaryCustomerNumber}-${record.deliveryDate}`;
        const isExpanded = expandedRows.includes(key);

        return (
          <span
            //onClick={() => handleExpandRow(record.site, record.customerNumber, record.deliveryDate)}
            onClick={() => handleExpandRow(record.site, record.customerNumber, record.deliveryDate, record.primaryCustomerNumber)}
            style={{ cursor: 'pointer', fontSize: '16px', color: '#1890ff', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingLeft: '0', marginLeft: '0' }}
          >
            {isExpanded ? <CaretDownOutlined /> : <  CaretRightOutlined />}
          </span>
        );
      },
    },
    {
      title: t('site'),
      dataIndex: 'site',
      sorter: true,
      width: 80,
      onHeaderCell: column => ({ width: 80 }),
    },
    {
      title: 'NID',
      dataIndex: 'nationalId',
      sorter: true,
      width: 80,
      onHeaderCell: column => ({ width: 80 }),
    },
    {
      title: 'Concept ID',
      dataIndex: 'conceptId',
      sorter: true,
      width: 110,
      onHeaderCell: column => ({ width: 110 }),
      render: text => {
        // Add null check for text before calling trim()
        if (text !== null && text !== undefined && String(text).trim()) {
          return (
            <span
              style={{
                background: '#f0f0f0',
                borderRadius: '4px',
                padding: '2px 6px',
                fontSize: '12px',
              }}
            >
              {text}
            </span>
          );
        }
        return null;
      },
    },
    // {
    //   title: t('customer#'),
    //   dataIndex: 'customerNumber',
    //   sorter: true,
    //   width: 140,
    //   onHeaderCell: column => ({ width: 140 }),
    // },
    {
      title: t('Primary Customer #'),
      dataIndex: 'primaryCustomerNumber',
      sorter: true,
      width: 160,
      onHeaderCell: column => ({ width: 160 }),
    },
    {
      title: 'Orders',
      dataIndex: 'orders',
      sorter: true,
      width: 50,
      onHeaderCell: column => ({ width: 50 }),
      render: value => (
        <span /*style={{ color: '#1890ff', fontWeight: 600 }}*/>{value}</span>
      ),
    },
    {
      title: t('dashboard_customerName'),
      // dataIndex: 'customerName',
      dataIndex: 'primaryCustomerName',
      sorter: true,
      width: 200,
      onHeaderCell: column => ({ width: 200 }),
    },
    {
      title: t('scName'),
      dataIndex: 'scName',
      sorter: true,
      width: 150,
      onHeaderCell: column => ({ width: 150 }),
    },
    {
      title: t('dashboard_accountType'),
      dataIndex: 'accountType',
      sorter: true,
      width: 110,
      onHeaderCell: column => ({ width: 110 }),
    },
    {
      title: 'Total Cases',
      dataIndex: 'totalCases',
      sorter: true,
      width: 130,
      onHeaderCell: column => ({ width: 130 }),
    },
    {
      title: t('deliveryDT'),
      dataIndex: 'deliveryDate',
      sorter: true,
      width: 120,
      onHeaderCell: column => ({ width: 120 }),
      render: value => {
        if (!value) return '';
        const str = value.toString();
        return `${str.slice(4, 6)}/${str.slice(6, 8)}/${str.slice(0, 4)}`;
      },
    },
    {
      title: t('status'),
      dataIndex: 'status',
      // sorter: true,
      width: 100,
      onHeaderCell: column => ({ width: 100 }),
      render: value => {
        const colorMap = {
          OPEN: '#fa8c16',
          PENDING: '#d4380d',
          SHIPPED: '#52c41a',
          ROUTED: '#1890ff',
          'SEND TO ROUTING': '#fadb14',
        };
        return (
          <span style={{ color: colorMap[String(value).trim()] || '#000', fontWeight: 600 }}>
            {value}
          </span>
        );
      },
    },
    {
      title: 'Dollar Value',
      dataIndex: 'orderTotal',
      sorter: true,
      width: 120,
      onHeaderCell: column => ({ width: 120 }),
      render: value => (
        <span style={{ color: '#52c41a', fontWeight: 600 }}>
          ${Number(value).toFixed(2)}
        </span>
      ),
    },
  ];


  const handleCaseCountChange = (value) => {
    setCaseCountFilter(value);
    setPagination({
      ...CONST_PAGINATION,
      // total: pagination.total,
      total: paginationTotal, // Use totalCount from Redux state for Under Min
    });
    setSorting(undefined);
    setExpandedRows([]);
    setExpandedData({});

  };

  // const handleExpandRow = (site, customerNumber, deliveryDate) => {
  //   const key = `${site}-${customerNumber}-${deliveryDate}`;
  const handleExpandRow = (site, customerNumber, deliveryDate, primaryCustomerNumber) => {
    const key = `${site}-${primaryCustomerNumber}-${deliveryDate}`;


    if (expandedRows.includes(key)) {
      setExpandedRows(prev => prev.filter(k => k !== key));
    } else {
      setExpandedRows(prev => [...prev, key]);

      //if (!expandedData[key]) {
        setLoadingExpandedKey(key);
        fetchExpandedUnderMinDetails({
          site,
          // customerNumber,
          primaryShipTo: primaryCustomerNumber,
          deliveryDate,
          caseCount: caseCountFilter,
        }).then(data => {
          // Handle both array directly or nested in data property
          const result = Array.isArray(data) ? data : (data?.data || []);
          setExpandedData(prev => ({
            ...prev,
            [key]: result,
          }));
        }).catch(err => {
          console.error('Failed to fetch expanded details:', err);
          setExpandedRows(prev => prev.filter(k => k !== key));
          setExpandedData(prev => ({
            ...prev,
            [key]: [],
          }));
        })
          .finally(() => {
            setLoadingExpandedKey(prev => (prev === key ? null : prev));
          });

      // }
    }
  };


  // const expandedRowRender = (record) => {
  //   const key = `${record.site}-${record.customerNumber}-${record.deliveryDate}`;
  //   const data = expandedData[key];
  //   const isLoading = !data && fetchExpandedUnderMinDetailsPending;

  //   return (
  //     <Spin spinning={isLoading}>
  //       <div style={{
  //         padding: '12px 16px',
  //         backgroundColor: '#f5f5f5',
  //         width: '100%',
  //         boxSizing: 'border-box',
  //       }}>
  //         {data && data.length > 0 ? (
  //           <div style={{ width: '100%' }}>
  //             {/* Order Numbers */}
  //             <div style={{ marginBottom: '6px', display: 'flex', flexWrap: 'wrap' }}>
  //               <span style={{ fontSize: '13px', fontWeight: 600, color: '#000000', whiteSpace: 'nowrap' }}>
  //                 Order Numbers:&nbsp;
  //               </span>
  //               <span style={{ fontSize: '13px', color: '#595959', wordBreak: 'break-word' }}>
  //                 {data.map(item => item.orderNumber).join(', ')}
  //               </span>
  //             </div>

  //             {/* Order Details Header */}
  //             <div style={{ marginBottom: '6px' }}>
  //               <span style={{ fontSize: '13px', fontWeight: 600, color: '#000000' }}>
  //                 Order Details:
  //               </span>
  //             </div>

  //             {/* Order Details List */}
  //             <div style={{ marginLeft: '8px' }}>
  //               {data.map((item, idx) => (
  //                 <div key={idx} style={{
  //                   fontSize: '13px',
  //                   color: '#595959',
  //                   marginBottom: idx !== data.length - 1 ? '4px' : '0px',
  //                   whiteSpace: 'nowrap',
  //                 }}>
  //                   • Order #{item.orderNumber}: {item.totalCases} cases | ${Number(item.totalAmount).toFixed(2)}
  //                 </div>
  //               ))}
  //             </div>
  //           </div>
  //         ) : !isLoading ? (
  //           <div style={{
  //             textAlign: 'center',
  //             color: '#8c8c8c',
  //             fontSize: '13px'
  //           }}>
  //             No order details available
  //           </div>
  //         ) : null}
  //       </div>
  //     </Spin>
  //   );
  // };

  const expandedRowRender = (record) => {
    const key = `${record.site}-${record.primaryCustomerNumber}-${record.deliveryDate}`;
    const data = expandedData[key];
    // const isLoading = !data && fetchExpandedUnderMinDetailsPending;
    const isLoading = loadingExpandedKey === key;

    if (isLoading) {
      return <Spin spinning={true} />;
    }

    if (!data || data.length === 0) {
      return (
        <div style={{
          padding: '12px 16px',
          backgroundColor: '#f5f5f5',
          textAlign: 'center',
          color: '#8c8c8c',
          fontSize: '13px'
        }}>
          {/* {fetchExpandedUnderMinDetailsPending ? (
            <Spin spinning={true} />
          ) : (
            'No order details available'
          )} */}
          {isLoading ? <Spin spinning={true} /> : 'No order details available'}
        </div>
      );
    }

    // Desktop View
    return (
      <div style={{
        padding: '16px',
        backgroundColor: '#f5f5f5',
        width: '100%',
        boxSizing: 'border-box',
      }}>
        <div className="is-show-pc">
          <h4 style={{ marginTop: 0, marginBottom: '12px', fontSize: '14px', fontWeight: 600, color: '#1890ff' }}>
            SHIP-TO LEVEL DETAILS
          </h4>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            backgroundColor: '#fff',
            border: '1px solid #d9d9d9',
          }}>
            <thead>
              <tr style={{ backgroundColor: '#e8e8f0' }}>
                <th style={{
                  padding: '8px 12px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderBottom: '1px solid #d9d9d9',
                }}>
                  NID
                </th>
                <th style={{
                  padding: '8px 12px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderBottom: '1px solid #d9d9d9',
                }}>
                  Concept
                </th>
                <th style={{
                  padding: '8px 12px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderBottom: '1px solid #d9d9d9',
                }}>
                  Customer #
                </th>
                <th style={{
                  padding: '8px 12px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderBottom: '1px solid #d9d9d9',
                }}>
                  Customer Name
                </th>
                <th style={{
                  padding: '8px 12px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderBottom: '1px solid #d9d9d9',
                }}>
                  SC Name
                </th>
                <th style={{
                  padding: '8px 12px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderBottom: '1px solid #d9d9d9',
                }}>
                  Account Type
                </th>
                {/* <th style={{
                  padding: '8px 12px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderBottom: '1px solid #d9d9d9',
                }}>
                  Order Status
                </th> */}
                <th style={{
                  padding: '8px 12px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderBottom: '1px solid #d9d9d9',
                }}>
                  Dollar Value
                </th>
                <th style={{
                  padding: '8px 12px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: 600,
                  borderBottom: '1px solid #d9d9d9',
                }}>
                  Order Details
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, idx) => (
                <tr key={idx} style={{ borderBottom: '1px solid #d9d9d9' }}>
                  <td style={{ padding: '8px 12px', fontSize: '12px', color: '#000' }}>
                    {item.nationalId || '-'}
                  </td>
                  {/* Concept Column with Parent Badge */}
                  <td style={{ padding: '8px 12px', fontSize: '12px', color: '#000' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                      <span style={{ color: '#1890ff', fontWeight: 600, cursor: 'pointer' }}>
                        {item.conceptId || '-'}
                      </span>
                      {item.customerNumber === record.primaryCustomerNumber && (
                        <span style={{
                          backgroundColor: '#1890ff',
                          color: '#fff',
                          padding: '2px 8px',
                          borderRadius: '3px',
                          fontSize: '10px',
                          fontWeight: 600,
                          whiteSpace: 'nowrap'
                        }}>
                          Parent
                        </span>
                      )}
                    </div>
                  </td>
                  <td style={{ padding: '8px 12px', fontSize: '12px', color: '#000' }}>
                    {item.customerNumber || '-'}
                  </td>
                  <td style={{ padding: '8px 12px', fontSize: '12px', color: '#000', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {item.customerName || '-'}
                  </td>
                  <td style={{ padding: '8px 12px', fontSize: '12px', color: '#000', maxWidth: '150px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {item.scName || '-'}
                  </td>
                  <td style={{ padding: '8px 12px', fontSize: '12px', color: '#000' }}>
                    {item.accountType || '-'}
                  </td>
                  {/* <td style={{ padding: '8px 12px', fontSize: '12px' }}>
                    {item.status ? (
                      <span style={{
                        color: (() => {
                          const colorMap = {
                            OPEN: '#fa8c16',
                            PENDING: '#d4380d',
                            SHIPPED: '#52c41a',
                            ROUTED: '#1890ff',
                          };
                          return colorMap[item.status] || '#000';
                        })(),
                        fontWeight: 600
                      }}>
                        {item.status}
                      </span>
                    ) : '-'}
                  </td> */}
                  <td style={{ padding: '8px 12px', fontSize: '12px', fontWeight: 600}}>
                    ${Number(item.orderTotal || 0).toFixed(2)}
                  </td>
                  <td style={{ padding: '8px 12px', fontSize: '12px', color: '#000' }}>
                    {item.customerLevelOrderDetails && item.customerLevelOrderDetails.length > 0 ? (
                      <div>
                        {item.customerLevelOrderDetails.map((order, oIdx) => (
                          <div key={oIdx} style={{ marginBottom: oIdx !== item.customerLevelOrderDetails.length - 1 ? '4px' : '0', whiteSpace: 'nowrap' }}>
                            <span style={{ color: '#1890ff', cursor: 'pointer', fontWeight: 600 }}>
                              #{order.orderNumber}
                            </span>
                            {/* <span style={{ marginLeft: '4px', color: '#595959' }}>
                              : {order.totalCases} cases | ${Number(order.orderTotal).toFixed(2)}
                            </span> */}
                            <span style={{ marginLeft: '4px', color: '#595959', display: 'inline-flex', alignItems: 'center', gap: '3px' }}>
                              : {order.totalCases} cases | ${Number(order.orderTotal).toFixed(2)}
                              <span style={{ marginLeft: '2px', color: '#595959' }}>|</span>
                              <span style={{
                                color: (() => {
                                  const colorMap = { OPEN: '#fa8c16', SHIPPED: '#52c41a', ROUTED: '#1890ff', 'SEND TO ROUTING': '#fadb14' };
                                  return colorMap[String(order.orderStatus).trim()] || '#000';
                                })(),
                                fontSize: '10px',
                                fontWeight: 400,
                              }}>
                                {order.orderStatus || '-'}
                              </span>
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  if (title === 'Errored Lines') {
    columns.splice(7, 2, itemNoColumnObj, itemDescColumnObj, errorColumnObj);
  } else if (title === 'EXPD Details') {
    columns.splice(7, 2, itemNoColumnObj, itemDescColumnObj, ...expdColumnObj);
  } else if (title === 'Subs') {
    columns.splice(0, columns.length, ...subsExceptionsColumnObj);
  } else if (title === 'Locked/Errored') {
    columns.splice(7, 0, errorColumnObj);
  } else if(title === 'Under Min') {
    columns.splice(0, columns.length, ...underMinimumColumns);
  } else {
    columns.splice(7, 0, commonColumnObj);
  }

  if ((typeLabel && typeLabel.orderType !== undefined) || title === 'Locked/Errored' || title === 'After Cut Off') {
    columns.splice(9, 0, statusColumnObj);
  }

  const exportHealthCheckReports = () => {
    //if (totals > 5001) {
    if(paginationTotal > 5001) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
      const sheetColConfig = [
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 25 },
        { wch: 13 },
        { wch: 16 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
      ];
      const formdata = {
        // ...detailsCondition,
        ...baseDetailsCondition,
        ...typeLabel,
        ...sorting,
        ...(title === 'Under Min' && { caseCount: caseCountFilter }),
      };
      const timing = Date.now();
      exportReportData(formdata).then(data => {
        // Filter out the expander column for Under Min export
        const exportColumns = title === 'Under Min'
          ? columns.filter(col => col.key !== 'expander')
          : columns;

        const sheetObj = [
          {
            // headers: columns,
            headers: exportColumns,
            data,
            sheetName: null,
            sheetColConfig,
          },
        ];
        downloadFile(`${title} Report`, sheetObj);
        datadogRum.addAction(`Export ${title} report`, {
          // headers: columns,
          headers: exportColumns,
          data,
          sheetName: null,
          sheetColConfig,
        });
      });
      datadogRum.onReady(function() {
        datadogRum.addTiming(`Export ${title} report`, timing);
      });
    }
  };

  const handleOrderReportList = (pagination, sorting) => {
    const formdata = {
      // ...detailsCondition,
      ...baseDetailsCondition,
      ...typeLabel,
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      ...(sorting && { sortedBy: sorting.sortedBy, sort: sorting.sort }),
      ...(title === 'Under Min' && { caseCount: caseCountFilter }),
    };
    const timing = Date.now();
    fetchOrderReportData(formdata);
    datadogRum.onReady(function() {
      datadogRum.addTiming(`${title}`, timing);
    });
  };

  // const onTableChange = (page, filters, sorter) => {
  //   setShowAlert(false);
  //   const sort =
  //     Object.keys(sorter).length > 0 && sorter.order !== undefined
  //       ? {
  //           sortedBy: sorter.field,
  //           sort: sorter.order,
  //         }
  //       : sorting;
  //   setPagination({
  //     ...pagination,
  //     pageIndex: 1,
  //   });
  //   setSorting(sort);
  // };

  const onTableChange = (page, filters, sorter) => {
    setShowAlert(false);

    let sort = undefined;  // Start with undefined

    if (Object.keys(sorter).length > 0 && sorter.order !== undefined) {
      sort = {
        sortedBy: sorter.field,
        sort: sorter.order,
      };
    }
    // If condition fails, sort remains undefined

    setPagination({
      ...pagination,
      pageIndex: 1,
    });
    setSorting(sort);  // Sets to undefined on 3rd click
  };

  const onPaginationChange = (page, changedPageSize) => {
    setShowAlert(false);
    setRevealedFields({});
    setExpandedRows([]);
    setExpandedData({});
    let currPageIndex = page;
    if (pagination.pageSize !== changedPageSize) {
      currPageIndex = 1;
    }
    setPagination({
      ...pagination,
      pageIndex: currPageIndex,
      pageSize: changedPageSize,
    });
  };
  const [checkedRowList, setCheckedRowList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setCheckedRowList(selectedRows);
      setSelectedRowKeys(selectedRowKeys);
    },
    selectedRowKeys,
  };
  const handleEdit = record => {};
  const handleDelete = record => {};

  const actionColumn = {
    title: 'Actions',
    dataIndex: '',
    width: 60,
    blankWidth: 60,
    render: (value, record) => {
      return (
        <div className="flex parent-actions">
          <Button
            title="Edit"
            style={{ width: '24px' }}
            disabled
            type="link"
            icon={<EditCalendarIcon />}
            onClick={() => {
              handleEdit(record);
            }}
          >
            {/* <FontAwesomeIcon icon={faEdit} color="#A1A1A1" style={{ height: "15px", width: "15px" }} /> */}
          </Button>
          <Button
            title="Delete"
            style={{ paddingLeft: '5px', width: '42px' }}
            disabled
            type="link"
            icon={<CancelIcon />}
            onClick={() => {
              handleDelete(record);
            }}
          >
            {/* <FontAwesomeIcon icon={faTimesSquare} color="#A1A1A1" style={{ height: "15px", width: "15px" }} /> */}
          </Button>
        </div>
      );
    },
  };
  const handleOnRowClick = (value, label, record) => {
    setOrderDetailModalVisible(true);
    saveReportsKeyValue({...reportsKeyValue,orderNumber:value,site:record.site});
  };
  const renderTableLinkButton = (value, label, record, isNestColumn) => {
    return (
      <Button
        type="link"
        onClick={() => handleOnRowClick(value, label, record)}
        // className={(label === 'offDaySales' || ((label === 'offDayOrders' || label === 'largeHits' || label === 'underXOrY') && tabKey === 'SC in Action')) && value === 0?"ant-btn-link-disabled":""}
      >
        {value}
      </Button>
    );
  };
  const renderElementIndex = {
    toggleModal: renderTableLinkButton,
    // renderBadge: renderBadge,
  };
  let tableColumns = renderTableColumns(columns, null, renderElementIndex);
  // tableColumns.forEach(item => {
  //   item.title = t(item.title);
  // });
  // tableColumns.splice(columns.length, 0, actionColumn);
  
  const handleFieldClick = useCallback((key) => {
  setRevealedFields(prev => ({ ...prev, [key]: !prev[key] }));
}, []);
  const renderMobileValue = (value, dataIndex, record, colItem, recordKey) => {
    const truncatable = ['customerName', 'scName', 'itemDescription', 'exceptionDescription'].includes(dataIndex);
    const key = `${recordKey}-${dataIndex}`;
    const revealed = revealedFields[key];
    
    if (colItem.toggleModal)
    return renderTableLinkButton(value, dataIndex, record);
    if (dataIndex === 'totals') {
      if (value === null || value === 0) return '$0.00';
      return `$${value.toLocaleString('zh', { minimumFractionDigits: 2 })}`;
    } else if (dataIndex === 'orderTotal') {
      // Handle Dollar Value for Under Min tab
      if (title === 'Under Min') {
        return (
          <span style={{ color: '#52c41a', fontWeight: 600 }}>
            ${Number(value).toFixed(2)}
          </span>
        );
      }
    } else if (dataIndex === 'deliveryDate') {
      if (title === 'Under Min') {
      // Under Min format: 20260414 -> 04/14/2026
      if (!value) return '';
      const str = value.toString();
      return `${str.slice(4, 6)}/${str.slice(6, 8)}/${str.slice(0, 4)}`;
    }
      return moment(value, DASH_DATE_FORMAT).format(SLASH_DATE_FORMAT);
    } else if (title === 'Under Min' && dataIndex === 'orders') {
      return `${value}`;
    } else if (dataIndex === 'status' || dataIndex === 'exceptionStatus') {
      // Handle status with color mapping for Under Min tab
      if (title === 'Under Min' && dataIndex === 'status') {
        const colorMap = {
          OPEN: '#fa8c16',
          PENDING: '#d4380d',
          SHIPPED: '#52c41a',
          ROUTED: '#1890ff',
          'SEND TO ROUTING': '#fadb14',
        };
        return (
          <span style={{ color: colorMap[value] || '#000', fontWeight: 600 }}>
            {value}
          </span>
        );
      }
      return <div className={statusColor}>{value}</div>;
    } else if (dataIndex === 'originalItemUnitPrice' || dataIndex === 'subItemUnitPrice') {
      if (value === 0) return '$0.000';
      return value && `$${value.toLocaleString('zh', { minimumFractionDigits: 3 })}`;
    } else if (truncatable && value) {
      return (
        <div
          onClick={() => handleFieldClick(key)}

          style={{
            cursor: 'pointer',
            overflow: revealed ? 'visible' : 'hidden',
            textOverflow: revealed ? 'clip' : 'ellipsis',
            whiteSpace: revealed ? 'normal' : 'nowrap',
            wordBreak: revealed ? 'break-word' : 'normal',
            maxWidth: revealed ? '100%' : '15ch',
            display: 'inline-block',
            color: 'inherit',
            fontSize: revealed ? '11px' : 'inherit',
            lineHeight: revealed ? '1.2' : 'inherit',
            marginTop: revealed ? '4px' : '0',
            marginBottom: revealed ? '4px' : '0',
          }}
        >
          {value}
        </div>
      );
    } else {
      return value && `${value}`;
    }
  };
  return (
    <div>
      <Modal
        className="dashboard-order-report-modal"
        title={
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            flexDirection: title === 'Under Min' ? 'column' : 'row', // Stack vertically for Under Min
            gap: title === 'Under Min' ? '10px' : '0', // Add gap between rows for Under Min
          }}>
            {/* Left - Title */}
            <span>{`${t(modalkey)}`}</span>

            {/* Right - Only show for Under Min */}
            {/* {title === 'Under Min' && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{
                  fontSize: '14px',
                  fontWeight: 400,
                  color: '#000',
                  whiteSpace: 'nowrap'
                }}>
                  Case Count Below:
                </span>
                <Select
                  value={caseCountFilter}
                  placeholder="-- Select --"
                  onChange={handleCaseCountChange}
                  style={{ width: 60 }}
                  // options={[
                  //   { label: '15', value: 15 },
                  //   { label: '20', value: 20 },
                  //   { label: '25', value: 25 },
                  //   { label: '30', value: 30 },
                  // ]}
                  options={[
                    { label: '10', value: 10 },
                    { label: '15', value: 15 },
                    { label: '20', value: 20 },
                  ]}
                />
                <ExportButton
                  dataSource={orderReportData}
                  exportReports={exportHealthCheckReports}
                />
              </div>
            )} */}
            {title === 'Under Min' && (
              <>
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#000',
                    whiteSpace: 'nowrap'
                  }}>
                    Case Count Below:
                  </span>
                  <Select
                    value={caseCountFilter}
                    placeholder="-- Select --"
                    onChange={handleCaseCountChange}
                    style={{ width: 60 }}
                    options={[
                      { label: '10', value: 10 },
                      { label: '15', value: 15 },
                      { label: '20', value: 20 },
                    ]}
                  />
                  <ExportButton
                    dataSource={orderReportData}
                    exportReports={exportHealthCheckReports}
                  />
                  <div className="is-show-pc">
                    <Button
                      type="default"
                      onClick={handleRefreshUnderMin}
                      loading={fetchOrderReportDataPending}
                    >
                      Refresh
                    </Button>
                  </div>
                </div>

                {/* Mobile-only: place Refresh button on its own line below the controls */}
                <div
                  className="is-show-mobile"
                  style={{
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                  <Button
                    type="default"
                    onClick={handleRefreshUnderMin}
                    loading={fetchOrderReportDataPending}
                    style={{ display: 'inline-block' }}
                  >
                    Refresh
                  </Button>
                </div>
              </>
            )}
          </div>
        }
        visible={isReportModalVisible}
        onCancel={toggleReportModal}
        // width={1030}
        width={title === 'Under Min' ? 1500 : 1030}
        destroyOnClose={true}
        footer={null}
        afterClose={resetOrderReport}
        maskClosable={false}
      >
        {/* <div className="report-export-button-modal flex justify-end">
        <Button type="link" title="Export" style={{ marginLeft: '-20px' }} onClick={exportHealthCheckReports} disabled={_.isEmpty(orderReportData)}>
          <FontAwesomeIcon icon={faFileExport} color={_.isEmpty(orderReportData)?"#a1a1a2":"#6b6b6c"} style={{ height: "20px", width: "20px" }} />
          <p style={{ marginTop: "-5px", fontSize: "11px", marginLeft: "-3px",  color: (_.isEmpty(orderReportData) ? "#a1a1a2" : "#6b6b6c") }}>Export</p>
        </Button>
      </div> */}
        {title !== 'Under Min' && (
        <div className="report-export-button-modal flex justify-end">
          <ExportButton dataSource={orderReportData} exportReports={exportHealthCheckReports} />
        </div>
      )}
        <Table
          key={`table-${caseCountFilter}-${tableKey}`}
          rowKey={
            title === 'Under Min'
              ? record => `${record.site}-${record.primaryCustomerNumber}-${record.deliveryDate}`
              : record => Math.random()
          }
          className="dashboard-order-report-table is-show-pc"
          loading={fetchOrderReportDataPending || exportReportDataPending}
          columns={tableColumns}
          dataSource={orderReportData}
          pagination={false}
          onChange={onTableChange}
          scroll={
            title === 'Under Min'
              ? { x: 'max-content' }  
              : { x: 'max-content', y: 250 }
          }
          expandable={{
            expandedRowRender: title === 'Under Min' ? expandedRowRender : null,
            expandedRowKeys: expandedRows,
            indentSize: 0,
            expandIcon: () => null,
            rowExpandable: record => title === 'Under Min',
            fixed: 'left',            
          }}
        />
        {/* <div className="is-show-mobile">
          <div className="reports-mobile-list">
           
            <Spin spinning={fetchOrderReportDataPending || exportReportDataPending }>
            <div className={!orderReportData ? "reports-no-data":"none"}>
              <Empty />
            </div>
            {orderReportData &&
              orderReportData.length > 0 &&
              orderReportData.map((record, index) => {
                return (
                  <div className="sia-mobile-box">
                   
                    <div className="sia-mobile-editandDelete">                    
                    </div>
                    <ul key={`${t(modalkey)}-${index}`}>
                      {columns.map((colItem, colIndex) => {
                        const titleOrder = colItem.title;
                        const dataIndex = colItem.dataIndex;
                        const value = record[dataIndex];
                        return (
                          <li key={`${titleOrder}-${dataIndex}-${colIndex}`}>
                            <span className="sub01">{titleOrder}</span>
                            <span className="sub02">
                              {renderMobileValue(value, dataIndex, record, colItem)}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
            </Spin>
          </div>
        </div> */}

        <div className="is-show-mobile">
          <div className="reports-mobile-list"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: (!orderReportData || orderReportData.length === 0) ? 'center' : 'flex-start',
              alignItems: (!orderReportData || orderReportData.length === 0) ? 'center' : 'flex-start',
              padding: '6px 0',
              minHeight: (!orderReportData || orderReportData.length === 0) ? '300px' : 'auto',
              gap: '8px'
            }}
          >
            {/* <Spin spinning={fetchOrderReportDataPending || exportReportDataPending}>
              <div className={!orderReportData ? "reports-no-data" : "none"}>
                <Empty />
              </div>
              {orderReportData &&
                orderReportData.length > 0 &&
                orderReportData.map((record, index) => { */}
            {!orderReportData || orderReportData.length === 0 ? (
              fetchOrderReportDataPending ? (
                <Spin spinning={true} size="large" />
              ) : (
                <div className="reports-no-data">
                  <Empty />
                </div>
              )
            ) : (
              <Spin spinning={fetchOrderReportDataPending || exportReportDataPending}>
                {orderReportData.map((record, index) => {
                  const recordKey = title === 'Under Min'
                    ? `${record.site}-${record.customerNumber}-${record.deliveryDate}`
                    : `record-${index}`;
                  // Under Min tab - with expand/collapse
                  if (title === 'Under Min') {
                    const key = `${record.site}-${record.primaryCustomerNumber}-${record.deliveryDate}`;
                    const isExpanded = expandedRows.includes(key);
                    const data = expandedData[key];

                    const isLoading = loadingExpandedKey === key;

                    return (
                      <div style={{ gap: '8px' }} key={`${key}-${index}`} className="sia-mobile-box">
                        {/* Expand/Collapse Button */}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                          <span
                            onClick={() => handleExpandRow(record.site, record.customerNumber, record.deliveryDate, record.primaryCustomerNumber)}
                            style={{ cursor: 'pointer', color: '#1890ff', fontSize: '14px' }}
                          >
                            {isExpanded ? <CaretDownOutlined /> : <CaretRightOutlined />}
                          </span>
                        </div>

                        {/* Expanded Data - Scrollable Table */}
                        {isExpanded && (
                          <div style={{
                            padding: '12px',
                            backgroundColor: '#f5f5f5',
                            marginBottom: '8px',
                            borderRadius: '4px',
                            overflowX: 'auto',
                            WebkitOverflowScrolling: 'touch'
                          }}>
                            {data && data.length > 0 ? (
                              <div>
                                <h4 style={{ marginTop: 0, marginBottom: '12px', fontSize: '13px', fontWeight: 600, color: '#1890ff' }}>
                                  SHIP-TO LEVEL DETAILS
                                </h4>
                                <table style={{
                                  width: '100%',
                                  minWidth: '700px',
                                  borderCollapse: 'collapse',
                                  backgroundColor: '#fff',
                                  border: '1px solid #d9d9d9',
                                }}>
                                  <thead>
                                    <tr style={{ backgroundColor: '#e8e8f0' }}>
                                      <th style={{ padding: '6px 10px', textAlign: 'left', fontSize: '10px', fontWeight: 600, borderBottom: '1px solid #d9d9d9', whiteSpace: 'nowrap' }}>
                                        NID
                                      </th>
                                      <th style={{ padding: '6px 10px', textAlign: 'left', fontSize: '10px', fontWeight: 600, borderBottom: '1px solid #d9d9d9', whiteSpace: 'nowrap' }}>
                                        Concept
                                      </th>
                                      <th style={{ padding: '6px 10px', textAlign: 'left', fontSize: '10px', fontWeight: 600, borderBottom: '1px solid #d9d9d9', whiteSpace: 'nowrap' }}>
                                        Customer #
                                      </th>
                                      <th style={{ padding: '6px 10px', textAlign: 'left', fontSize: '10px', fontWeight: 600, borderBottom: '1px solid #d9d9d9', whiteSpace: 'nowrap' }}>
                                        Customer Name
                                      </th>
                                      <th style={{ padding: '6px 10px', textAlign: 'left', fontSize: '10px', fontWeight: 600, borderBottom: '1px solid #d9d9d9', whiteSpace: 'nowrap' }}>
                                        SC Name
                                      </th>
                                      <th style={{ padding: '6px 10px', textAlign: 'left', fontSize: '10px', fontWeight: 600, borderBottom: '1px solid #d9d9d9', whiteSpace: 'nowrap' }}>
                                        Account Type
                                      </th>
                                      {/* <th style={{ padding: '6px 10px', textAlign: 'left', fontSize: '10px', fontWeight: 600, borderBottom: '1px solid #d9d9d9', whiteSpace: 'nowrap' }}>
                                        Order Status
                                      </th> */}
                                      <th style={{ padding: '6px 10px', textAlign: 'left', fontSize: '10px', fontWeight: 600, borderBottom: '1px solid #d9d9d9', whiteSpace: 'nowrap' }}>
                                        Dollar Value
                                      </th>
                                      <th style={{ padding: '6px 10px', textAlign: 'left', fontSize: '10px', fontWeight: 600, borderBottom: '1px solid #d9d9d9', whiteSpace: 'nowrap' }}>
                                        Order Details
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data.map((item, idx) => (
                                      <tr key={idx} style={{ borderBottom: '1px solid #d9d9d9' }}>
                                        <td style={{ padding: '6px 10px', fontSize: '10px', color: '#000', whiteSpace: 'nowrap' }}>
                                          {item.nationalId || '-'}
                                        </td>
                                        <td style={{ padding: '6px 10px', fontSize: '10px', color: '#000', whiteSpace: 'nowrap' }}>
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <span style={{ color: '#1890ff', fontWeight: 600 }}>
                                              {item.conceptId || '-'}
                                            </span>
                                            {item.customerNumber === record.primaryCustomerNumber && (
                                              <span style={{
                                                backgroundColor: '#1890ff',
                                                color: '#fff',
                                                padding: '2px 8px',
                                                borderRadius: '3px',
                                                fontSize: '10px',
                                                fontWeight: 600,
                                                whiteSpace: 'nowrap'
                                              }}>
                                                Parent
                                              </span>
                                            )}
                                          </div>
                                        </td>
                                        <td style={{ padding: '6px 10px', fontSize: '10px', color: '#000', whiteSpace: 'nowrap' }}>
                                          {item.customerNumber || '-'}
                                        </td>
                                        <td style={{ padding: '6px 10px', fontSize: '10px', color: '#000', maxWidth: '120px' }}>
                                          {item.customerName ? (
                                            <span
                                              onClick={() => handleFieldClick(`${key}-${idx}-custName`)}
                                              style={{
                                                cursor: 'pointer',
                                                display: 'inline-block',
                                                maxWidth: '120px',
                                                whiteSpace: revealedFields[`${key}-${idx}-custName`] ? 'normal' : 'nowrap',
                                                overflow: revealedFields[`${key}-${idx}-custName`] ? 'visible' : 'hidden',
                                                textOverflow: revealedFields[`${key}-${idx}-custName`] ? 'clip' : 'ellipsis',
                                                wordBreak: revealedFields[`${key}-${idx}-custName`] ? 'break-word' : 'normal',
                                              }}
                                            >
                                              {item.customerName}
                                            </span>
                                          ) : '-'}
                                        </td>
                                        <td style={ { padding: '6px 10px', fontSize: '10px', color: '#000', maxWidth: '100px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                          {item.scName || '-'}
                                        </td>
                                        <td style={{ padding: '6px 10px', fontSize: '10px', color: '#000', whiteSpace: 'nowrap' }}>
                                          {item.accountType || '-'}
                                        </td>
                                        {/* <td style={{ padding: '6px 10px', fontSize: '10px', whiteSpace: 'nowrap' }}>
                                          {item.status ? (
                                            <span style={{
                                              color: (() => {
                                                const colorMap = {
                                                  OPEN: '#fa8c16',
                                                  PENDING: '#d4380d',
                                                  SHIPPED: '#52c41a',
                                                  ROUTED: '#1890ff',
                                                  'SEND TO ROUTING': '#fadb14',
                                                };
                                                return colorMap[item.status] || '#000';
                                              })(),
                                              fontWeight: 600
                                            }}>
                                              {item.status}
                                            </span>
                                          ) : '-'}
                                        </td> */}
                                        <td style={{ padding: '6px 10px', fontSize: '10px', fontWeight: 600, whiteSpace: 'nowrap' }}>
                                          ${Number(item.orderTotal || 0).toFixed(2)}
                                        </td>
                                        <td style={{ padding: '6px 10px', fontSize: '10px', color: '#000', minWidth: '140px' }}>
                                          {item.customerLevelOrderDetails && item.customerLevelOrderDetails.length > 0 ? (
                                            <div>
                                              {item.customerLevelOrderDetails.map((order, oIdx) => (
                                                <div key={oIdx} style={{ marginBottom: oIdx !== item.customerLevelOrderDetails.length - 1 ? '2px' : '0', whiteSpace: 'nowrap' }}>
                                                  <span style={{ color: '#1890ff', fontWeight: 600 }}>
                                                    #{order.orderNumber}
                                                  </span>
                                                  {/* <span style={{ marginLeft: '4px', color: '#595959', fontSize: '9px' }}>
                                                    {order.totalCases} cases | ${Number(order.orderTotal).toFixed(2)}
                                                  </span> */}
                                                  <span style={{ marginLeft: '4px', color: '#595959', display: 'inline-flex', alignItems: 'center', gap: '3px' }}>
                                                    {order.totalCases} cases | ${Number(order.orderTotal).toFixed(2)}
                                                    <span style={{ marginLeft: '2px', color: '#595959' }}>|</span>
                                                    <span style={{
                                                      color: (() => {
                                                        const colorMap = {
                                                          OPEN: '#fa8c16',
                                                          PENDING: '#d4380d',
                                                          SHIPPED: '#52c41a',
                                                          ROUTED: '#1890ff',
                                                          'SEND TO ROUTING': '#fadb14',
                                                        };
                                                        return colorMap[String(order.orderStatus || '').trim()] || '#000';
                                                      })(),
                                                      fontSize: '10px',
                                                      fontWeight: 400,
                                                    }}>
                                                      {order.orderStatus || '-'}
                                                    </span>
                                                  </span>
                                                </div>
                                              ))}
                                            </div>
                                          ) : '-'}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : (
                              <>
                                {/* {fetchExpandedUnderMinDetailsPending ? (
                <Spin spinning={true} />
              ) : (
                <div style={{ textAlign: 'center', color: '#8c8c8c', fontSize: '13px' }}>
                  No order details available
                </div>
              )} */}
                                {isLoading ? <Spin spinning={true} /> : 'No order details available'}
                              </>
                            )}
                          </div>
                        )}

                {/* Record Fields */}
                <ul key={`${t(modalkey)}-${index}`}>
                  {columns.map((colItem, colIndex) => {
                    const titleOrder = colItem.title;
                    const dataIndex = colItem.dataIndex;
                    const value = record[dataIndex];
                    return (
                      <li key={`${titleOrder}-${dataIndex}-${colIndex}`}>
                        <span className="sub01" style={{ minWidth: '90px', whiteSpace: 'nowrap' }}>{titleOrder}</span>
                        <span className="sub02">
                          {renderMobileValue(value, dataIndex, record, colItem, recordKey)}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          }

          // All other tabs - existing implementation unchanged
          return (
            <div className="sia-mobile-box">
              <div className="sia-mobile-editandDelete">
              </div>
              <ul key={`${t(modalkey)}-${index}`}>
                {columns.map((colItem, colIndex) => {
                  const titleOrder = colItem.title;
                  const dataIndex = colItem.dataIndex;
                  const value = record[dataIndex];
                  return (
                    <li key={`${titleOrder}-${dataIndex}-${colIndex}`}>
                      {/* <span className="sub01">{titleOrder}</span>
                      <span className="sub02"> */}
                      <span className="sub01" style={{ minWidth: '120px', whiteSpace: 'nowrap' }}>{titleOrder}</span>
                      <span className="sub02" style={{ flex: 1, wordBreak: 'break-word' }}>
                        {renderMobileValue(value, dataIndex, record, colItem, recordKey)}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
                 );
                  //         })}
                  //     </Spin>
                  //   </div>
                  // </div>
                })}
              </Spin>
            )}
          </div>
        </div>

        <div className="flex justify-center">
          <Pagination
            style={{ textAlign: 'left', margin: '16px 0px' }}
            className={'report-pagination'}
            showSizeChanger
            current={pagination.pageIndex}
            pageSize={pagination.pageSize}
            total={pagination.total}
            pageSizeOptions={pagination.pageSizeOptions}
            onShowSizeChange={onPaginationChange}
            onChange={onPaginationChange}
          />
          {/* <div className="report-footer flex justify-end">
          <Button onClick={exportHealthCheckReports}>Export</Button>
          <Button onClick={toggleReportModal}>Close</Button>
        </div> */}
        </div>
      </Modal>
      <OrderDetailReportModal
        isOrderDetailModalVisible={isOrderDetailModalVisible}
        setOrderDetailModalVisible={setOrderDetailModalVisible}
        title={`${t(modalkey)} - ${reportsKeyValue.orderNumber}`}
      />
    </div>
  );
}

OrderReportModal.propTypes = {};
OrderReportModal.defaultProps = {};


